// Direct config mapping
const config = [
  { "frontEnd": "localhost", "backend": "http://localhost:4000/" },
//   { "frontEnd": "localhost", "backend": "http://azharbackend.wordquran.com/" },
  { "frontEnd": "azhar.wordquran.com", "backend": "https://azharbackend.wordquran.com/"},
  { "frontEnd": "nayab.wordquran.com", "backend": "https://azharbackend.wordquran.com/"},
  //{ "frontEnd": "kandahar.xaosoft.com", "backend": "https://schoolbackend.qatehkandahar.com/"},
  { "frontEnd": "nedaeroshan.xaosoft.com", "backend": "https://nedaeroshanbackend.xaosoft.com/"},
  { "frontEnd": "rawayatacademy.xaosoft.com", "backend": "https://rawayatacademybackend.xaosoft.com/" },
  { "frontEnd": "hodschool.wasily.net", "backend": "https://hodbackend.wasily.net/"},
  { "frontEnd": "test.wasily.net", "backend": "https://testbackend.wasily.net/"},
  { "frontEnd": "test.xaosoft.com", "backend": "https://testbackend.xaosoft.com/"},
  { "frontEnd": "app.jamiahakeemulummat.com", "backend": "https://backend.jamiahakeemulummat.com/"},
  { "frontEnd": "rawayat.wasily.net", "backend": "https://school.wasily.net/"},
  { "frontEnd": "darulquran.wordquran.com", "backend": "https://backend.kandaharscience.com/"},
  { "frontEnd": "rwps.wordquran.com", "backend": "https://backend.kandaharscience.com/"},
  { "frontEnd": "app.kandaharscience.com", "backend": "https://backend.kandaharscience.com/"},
  { "frontEnd": "osmanfirst.xaosoft.com", "backend": "https://backend.kandaharscience.com/"},
  { "frontEnd": "osmansecond.xaosoft.com", "backend": "https://backend.kandaharscience.com/"},
  { "frontEnd": "wayardanish.xaosoft.com", "backend": "https://backend.kandaharscience.com/"},
  { "frontEnd": "wiardanish.xaosoft.com", "backend": "https://backend.kandaharscience.com/"},
  { "frontEnd": "peshgaman.wordquran.com", "backend": "https://backend.kandaharscience.com/"},
  { "frontEnd": "print.xaosoft.com", "backend": `https://${sessionStorage.getItem('printURL')}/`}
];

// Get current host and match backend
const currentHost = window.location.hostname.replace('www.', '');
const match = config.find(item => currentHost.includes(item.frontEnd));
const web = match ? match.backend : 'http://localhost:4000/';

console.log('Current host:', currentHost);
console.log('Using backend:', web);

const initialState = {
    //website api's
    Login:`${web}login`,
    Web:`${web}WebSrn`,
    VerifiyMarksheet: `${web}markverify`,    
    // DashBoard Api's
    studentCards: `${web}dashboard/studentCards`,
    teacherCards: `${web}dashboard/teacherCards`,
    MobileApp: `${web}dashboard/mobileAppRegister`,
    MobileAppList: `${web}dashboard/mobileAppRegData`,
    Showparents: `${web}dashboard/showparents`,
    showchildren:`${web}dashboard/showchildren/`,
    assignChildren: `${web}dashboard/assignChildren`,
    removeChild: `${web}dashboard/removechild`,

    StudentRegistation: `${web}dashboard/studentReg`,
    TeacherRegistation: `${web}dashboard/teacherReg`,
    Imagelink: `${web}dashboard/createFolder`,
    // Class Api's
    CreateClass: `${web}dashboard/createClass`,
    ShowClass: `${web}dashboard/showclass`,
    showClassStudents: `${web}dashboard/showClassStudents/`,
    // Subjects 
    DeleteSubject: `${web}dashboard/deleteSubject`,
    ShowSubject: `${web}dashboard/ShowSubjects`,
    UpdateSubject: `${web}dashboard/UpdateSubject`,
    AddSubject: `${web}dashboard/addSubject`,
    //Student attendance api's
    ShortAttendance: `${web}dashboard/shortAttendance`,
    StuedentAttendence: `${web}dashboard/attendence`,
    Studentmaunaulattendence: `${web}dashboard/maunaulattendence`,
    Studentcurrentdayreport: `${web}dashboard/currentdayreport`,
    Studentshowattendence: `${web}dashboard/showattendence/`,
    //Teacher Attendance api's
    Teachermaunaulattendence: `${web}dashboard/Teacherattendence`,
    Teachercurrentdayreport:`${web}dashboard/showTeacherAttendence`,
    TeacherSalaryCalculate:`${web}dashboard/teacherSalaryCalculate`,
    //Studnets suggestion api
    studentsuggestion: `${web}dashboard/studentsuggestion`,
    teachersuggestion: `${web}dashboard/teachersuggestion`,
    imageServer: `${web}public/`,
    showoldFessDetails:`${web}dashboard/showoldFessDetails`,
    showoldsalaryDetails: `${web}dashboard/showoldsalaryDetails`,
    // Customize Rolls
    webroles: `${web}dashboard/webRoles`,
    veiwroles: `${web}dashboard/veiwroles`,
    assignroles: `${web}dashboard/assignroles/`,
    //Private Messages
    privateMessage: `${web}dashboard/privateMessage`,
    veiwMessages: `${web}dashboard/veiwMessages`,
    //Group Messages
    Allmembersmessage: `${web}dashboard/Allmembersmessage`,
    veiwAllmemberMessages: `${web}dashboard/veiwAllmemberMessages`,
    //selected messages
    selectedmessage:`${web}dashboard/selectedmessages`,
    //annnouncmentholidays
    annnouncmentholidays: `${web}dashboard/annnouncmentholidays`,
    //public announcement
    publicannouncemnet: `${web}dashboard/publicannnouncment`,
    addpublicannouncemnet: `${web}dashboard/addpublicannnouncment`,
    switchpublicannouncemnet: `${web}dashboard/switch`,
    //Collection        //Fees
    AddFess: `${web}dashboard/AddFees`,
    deleteFees: `${web}dashboard/deletefeesstudent`,
    clearFees: `${web}dashboard/clearFees`,
    annnounceFees: `${web}dashboard/annnounce`,
    //Salary
    AddSalary: `${web}dashboard/AddSalary`,
    clearSalary: `${web}dashboard/clearSalary`,
    annnounceSalary: `${web}dashboard/annnounceSalary`,
    //Report 
        //Teacher
    AddReportTeacher:`${web}dashboard/AddTeacherReport`,
    ShowReportTeacher:`${web}dashboard/showTeacherReport`,
    showSpecificTeacher: `${web}dashboard/showSpecificTeacher`,
    showSpecificTeacherdata: `${web}dashboard/showSpecificTeacherdata`,
        //Student
    AddReportStudent:`${web}dashboard/AddStudentReport`,
    ShowReportStudent:`${web}dashboard/showStudentReport`,
    showSpecificStudent: `${web}dashboard/showSpecificStudents`,

    // Shoqa
    showShoqa:`${web}dashboard/showShoqa`,
    addShoqa: `${web}dashboard/addShoqa`,
    checkShoqa: `${web}dashboard/checkShoqa`,
    //donation
    donation:`${web}dashboard/donation`,
    veiwDonation: `${web}dashboard/veiwDonation`,

    // expense
    expense: `${web}dashboard/expense`,
    veiwexpense: `${web}dashboard/veiwexpense`,
    expenseCategory: `${web}dashboard/expensecate`,
    expenseDelete: `${web}dashboard/expensedelete`,
    //income
    income: `${web}dashboard/income`,
    studentList: `${web}dashboard/studentslists`,
    profitLost: `${web}dashboard/profitlosthosteltransport`,
    //showlatefee
    showlatefee: `${web}dashboard/showlatefee`,
    //activation
        // student
    studentactivationshow: `${web}dashboard/activition/student`,
    studentActivitionInsertFee: `${web}dashboard/activition/insertfee`,
    studentActivitionUpdateActiviation: `${web}dashboard/activition/updateActiviation`,
        // teacher 
    teacheractivationshow: `${web}dashboard/activition/teacher`,
    teacherActivitionInsertFee: `${web}dashboard/activition/teacherinsertfee`,
    teacherActivitionUpdateActiviation: `${web}dashboard/activition/teacherupdateActiviation`,

    udpateStudentReg: `${web}dashboard/update/studentreg`,
    udpateTeacherReg: `${web}dashboard/update/teacherReg`,
    udpateTeacherClass: `${web}dashboard/update/teacherupdateclass`,

    StudentStatus:`${web}dashboard/student/status`,
    updateClass : `${web}dashboard/student/updateStatus`,

    //Result Report Card
    resultYear : `${web}dashboard/student/resultyear`,
    examCreation : `${web}dashboard/examcreation`,
    resultByClass : `${web}dashboard/student/resultyearfullclass`,
    resultByRoll : `${web}dashboard/student/resultyearsingle`,
    reportCardsByRoll : `${web}dashboard/student/reportcardsbyroll`,
    transferStudentToNewClass : `${web}dashboard/student/toclasstransfer`,
    disableClass : `${web}dashboard/student/disableclass`,
    
    //Transport and Others
    transport : `${web}dashboard/transport`,
    transportFeesReceived : `${web}dashboard/transportFeesReceived`,
    transportEnroll : `${web}dashboard/transportEnroll`,
    transportStopService : `${web}dashboard/transportStopService`,
    allTransport : `${web}dashboard/allTransport`,
    allDefaulters : `${web}dashboard/alldefaulters`,
    transportFeesAnnounce : `${web}dashboard/transportFeesAnnounce`,
    Updateandinsert: `${web}dashboard/Updateandinsert`, 
    otherFees : `${web}dashboard/otherFees`,
    allOtherFees : `${web}dashboard/allOtherFees`, 
    classFeesReport : `${web}dashboard/classfeesreport`,
    //Daily Cash
    DailyCash: `${web}dashboard/getroznamcha`,

    // Book store api
    Bookinsert: `${web}dashboard/store/insert`,
    Bookget: `${web}dashboard/store/get`,
    Bookhistory : `${web}dashboard/store/history`,
    InsertPayment: `${web}dashboard/store/insertpayment`,

    //mobile Announcement
    studentPromote: `${web}dashboard/studentpromote`,


};

const Api = (state = initialState) => {
        return state;
}
export default Api;
